// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2h5I-","alert":"SettungsInbox_alert__1TFqF"};